<div class="profile_step">
  <form [formGroup]="yourProfileForm">
    <div class="profile_step_header">
      {{ "MyProfile_AS_BusinessInformation" | translate }}
    </div>
    <div class="form-group">
      <label for="firstName"
        >{{ "MyProfile_YP_FirstName" | translate }}
        <span class="required">*</span></label
      >
      <input
        id="firstName"
        formControlName="firstName"
        type="text"
        class="form-control"
        maxlength="64"
      />
      <div *ngIf="firstName?.errors?.prohibitedSymbols" class="error_message">
        {{ firstName?.errors?.prohibitedSymbols }}
      </div>
    </div>
    <div class="form-group">
      <label for="lastName"
        >{{ "MyProfile_YP_LastName" | translate }}
        <span class="required">*</span></label
      >
      <input
        id="lastName"
        formControlName="lastName"
        type="text"
        class="form-control"
        maxlength="64"
      />
      <div *ngIf="lastName?.errors?.prohibitedSymbols" class="error_message">
        {{ lastName?.errors?.prohibitedSymbols }}
      </div>
    </div>
    <div class="form-group">
      <label for="workPhone"
        >{{ "MyProfile_YP_WorkPhone" | translate }}
        <span [hidden]="!isOptional()">({{ "QnA_Optional" | translate }})</span
        ><span [hidden]="isOptional()" class="required">*</span></label
      >
      <input
        id="workPhone"
        formControlName="workPhone"
        type="text"
        class="form-control"
        maxlength="64"
      />
      <div *ngIf="workPhone?.errors?.prohibitedSymbols" class="error_message">
        {{ workPhone?.errors?.prohibitedSymbols }}
      </div>
    </div>
    <div class="form-group">
      <label for="mobilePhone"
        >{{ "MyProfile_YP_MobilePhone" | translate }}
        <span>({{ "QnA_Optional" | translate }})</span></label
      >
      <input
        id="mobilePhone"
        formControlName="mobilePhone"
        type="text"
        class="form-control"
        maxlength="64"
      />
      <div *ngIf="mobilePhone?.errors?.prohibitedSymbols" class="error_message">
        {{ mobilePhone?.errors?.prohibitedSymbols }}
      </div>
    </div>
    <div class="form-group">
      <label for="companyName"
        >{{ "MyProfile_YP_CompanyName" | translate }}
        <span [hidden]="!isOptional()">({{ "QnA_Optional" | translate }})</span
        ><span [hidden]="isOptional()" class="required">*</span></label
      >
      <input
        id="companyName"
        formControlName="companyName"
        type="text"
        class="form-control"
        maxlength="64"
      />
      <div *ngIf="companyName?.errors?.prohibitedSymbols" class="error_message">
        {{ companyName?.errors?.prohibitedSymbols }}
      </div>
    </div>
    <div class="form-group">
      <label for="department"
        >{{ "MyProfile_YP_Department" | translate }}
        <span [hidden]="!isOptional()">({{ "QnA_Optional" | translate }})</span
        ><span [hidden]="isOptional()" class="required">*</span></label
      >
      <input
        id="department"
        formControlName="department"
        type="text"
        class="form-control"
        maxlength="64"
      />
      <div *ngIf="department?.errors?.prohibitedSymbols" class="error_message">
        {{ department?.errors?.prohibitedSymbols }}
      </div>
    </div>
    <div class="form-group">
      <label for="title"
        >{{ "MyProfile_YP_Title" | translate }}
        <span [hidden]="!isOptional()">({{ "QnA_Optional" | translate }})</span
        ><span [hidden]="isOptional()" class="required">*</span></label
      >
      <input
        id="title"
        formControlName="title"
        type="text"
        class="form-control"
        maxlength="64"
      />
      <div *ngIf="title?.errors?.prohibitedSymbols" class="error_message">
        {{ title?.errors?.prohibitedSymbols }}
      </div>
    </div>
    <br />
    <div class="profile_step_header">
      {{ "MyProfile_YP_CompanyAddress" | translate }}
    </div>
    <div class="form-group">
      <label for="street1"
        >{{ "MyProfile_YP_Address1" | translate }}
        <span [hidden]="!isOptional()">({{ "QnA_Optional" | translate }})</span
        ><span [hidden]="isOptional()" class="required">*</span></label
      >
      <input
        id="street1"
        formControlName="street1"
        type="text"
        class="form-control"
        maxlength="1024"
      />
      <div *ngIf="street1?.errors?.prohibitedSymbols" class="error_message">
        {{ street1?.errors?.prohibitedSymbols }}
      </div>
    </div>
    <div class="form-group">
      <label for="street2"
        >{{ "MyProfile_YP_Address2" | translate }}
        <span>({{ "QnA_Optional" | translate }})</span></label
      >
      <input
        id="street2"
        formControlName="street2"
        type="text"
        class="form-control"
        maxlength="1024"
      />
      <div *ngIf="street2?.errors?.prohibitedSymbols" class="error_message">
        {{ street2?.errors?.prohibitedSymbols }}
      </div>
    </div>
    <div class="form-group">
      <label for="country"
        >{{ "MyProfile_YP_Country" | translate }}
        <span [hidden]="!isOptional()">({{ "QnA_Optional" | translate }})</span
        ><span [hidden]="isOptional()" class="required">*</span></label
      >
      <select formControlName="country" class="form-control">
        <option *ngFor="let country of countries" [ngValue]="country">
          {{ country }}
        </option>
      </select>
    </div>
    <div class="form-group">
      <label for="state"
        >{{ "MyProfile_YP_State" | translate }}
        <span [hidden]="!isOptional()">({{ "QnA_Optional" | translate }})</span
        ><span [hidden]="isOptional()" class="required">*</span></label
      >
      <input
        id="state"
        formControlName="state"
        type="text"
        class="form-control"
        maxlength="128"
      />
      <div *ngIf="state?.errors?.prohibitedSymbols" class="error_message">
        {{ state?.errors?.prohibitedSymbols }}
      </div>
    </div>
    <div class="form-group">
      <label for="city"
        >{{ "MyProfile_YP_City" | translate }}
        <span [hidden]="!isOptional()">({{ "QnA_Optional" | translate }})</span
        ><span [hidden]="isOptional()" class="required">*</span></label
      >
      <input
        id="city"
        formControlName="city"
        type="text"
        class="form-control"
        maxlength="128"
      />
      <div *ngIf="city?.errors?.prohibitedSymbols" class="error_message">
        {{ city?.errors?.prohibitedSymbols }}
      </div>
    </div>
    <div class="form-group">
      <label for="zip"
        >{{ "MyProfile_YP_Zip" | translate }}
        <span [hidden]="!isOptional()">({{ "QnA_Optional" | translate }})</span
        ><span [hidden]="isOptional()" class="required">*</span></label
      >
      <input
        id="zip"
        formControlName="zip"
        type="text"
        class="form-control"
        maxlength="40"
      />
      <div *ngIf="zip?.errors?.prohibitedSymbols" class="error_message">
        {{ zip?.errors?.prohibitedSymbols }}
      </div>
    </div>
  </form>
</div>
